import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { belongsTo, attr, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
let InvoicegroupModel = (_dec = belongsTo('invoice', {
  inverse: 'invoicegroups',
  async: false
}), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('number', {
  currency: true
}), _dec6 = attr('number'), _dec7 = attr('string'), _dec8 = attr('number', {
  currency: true
}), _dec9 = attr('number', {
  currency: true
}), _dec0 = attr('number', {
  currency: true
}), _dec1 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec10 = belongsTo('project', {
  inverse: null,
  async: false
}), _dec11 = belongsTo('product', {
  inverse: null,
  async: false
}), _dec12 = hasMany('invoiceproduct', {
  inverse: null,
  async: false
}), _dec13 = hasMany('invoicetax', {
  inverse: null,
  async: false
}), _dec14 = attr('boolean'), _dec15 = attr('boolean', {
  defaultValue: false
}), _class = class InvoicegroupModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "invoice", _descriptor, this);
    _initializerDefineProperty(this, "rank", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "description", _descriptor4, this);
    _initializerDefineProperty(this, "price", _descriptor5, this);
    _initializerDefineProperty(this, "qta", _descriptor6, this);
    _initializerDefineProperty(this, "unit", _descriptor7, this);
    _initializerDefineProperty(this, "importo", _descriptor8, this);
    _initializerDefineProperty(this, "total", _descriptor9, this);
    _initializerDefineProperty(this, "fixed_price", _descriptor0, this);
    _initializerDefineProperty(this, "contact", _descriptor1, this);
    _initializerDefineProperty(this, "project", _descriptor10, this);
    _initializerDefineProperty(this, "product", _descriptor11, this);
    _initializerDefineProperty(this, "invoiceproducts", _descriptor12, this);
    _initializerDefineProperty(this, "invoicetaxes", _descriptor13, this);
    _initializerDefineProperty(this, "boolean_option1", _descriptor14, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor15, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "invoice", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "qta", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "unit", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "importo", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "fixed_price", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "project", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "product", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "invoiceproducts", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "invoicetaxes", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "boolean_option1", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { InvoicegroupModel as default };
//# sourceMappingURL=invoicegroup.js.map
